import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

interface SelectCompareInput {
    chatId: string;
    experimentId: string;
    selectedOption: "A" | "B";
    reason?: string;
}

interface SelectCompareOutput {
    winningText: string;
}

export function useSelectGoogleDriveCompareMutation() {
    return useMutation({
        mutationFn: async (input: SelectCompareInput): Promise<SelectCompareOutput> => {
            const res = await apiClient.selectGoogleDriveCompare({
                params: {
                    chatId: input.chatId,
                    experimentId: input.experimentId,
                },
                body: {
                    selectedOption: input.selectedOption,
                    reason: input.reason,
                },
            });

            if (res.status !== 200) {
                throw new Error("Failed to select Google Drive comparison winner");
            }

            return { winningText: res.body.winningText };
        },
    });
}
